import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { PARENT_MENU } from "@/pages/menuConfig";

export default function Belajar() {
  const navigate = useNavigate();
  return (
    <div className="pt-6">
      <div className="px-5 mb-5">
        <h1 className="font-heading text-2xl font-bold text-stone-800">Menu Belajar 📚</h1>
        <p className="text-stone-500 text-sm">Semua aktivitas & progres ananda</p>
      </div>
      <div className="px-5 grid grid-cols-2 gap-3">
        {PARENT_MENU.filter((m) => m.key !== "info" && m.key !== "profil-anak").map((m, i) => {
          const Icon = m.icon;
          return (
            <motion.button
              key={m.key}
              data-testid={`belajar-${m.key}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.04 }}
              onClick={() => navigate(m.path)}
              className="bg-white rounded-3xl border border-stone-200/60 p-4 shadow-sm flex items-center gap-3 active:scale-95 transition-transform"
            >
              <div className={`w-10 h-10 rounded-2xl ${m.color} flex items-center justify-center shrink-0`}>
                <Icon size={20} weight="duotone" />
              </div>
              <span className="font-heading font-semibold text-stone-700 text-xs leading-tight min-w-0">{m.label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
